// React
import { createContext } from "react"
import { DetailType } from "../utils"

export const RefundDetailContext = createContext<{
  item: DetailType
  onUpdate: (qty_refund: DetailType) => void
  onDelete: () => void
}>({
  item: {
    discount: 0,
    price_refund: 0,
    product_barcode: "",
    product_id: 0,
    product_name: "",
    qty_back_returned: 0,
    qty_return_item: 0,
    qty_unit: 0,
    quantity_unit_sell_convention: 0,
    tax_id: 0,
    tax_name: "",
    tax_rate: 0,
    total: 0,
    total_tax_collect: 0,
    unit_convention_name: "",
    unit_sell_measure_name: ""
  },
  onUpdate(_) {},
  onDelete() {}
})